import EditBotUserDialog from './EditBotUserDialog'

export default EditBotUserDialog


// WEBPACK FOOTER //
// ./src/components/EditBotUserDialog/index.js